/*
Author: Chathuraka Mallawa Arachchi
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

import downArrow from '@/assets/downArrow.svg';
import upArrow from '@/assets/upArrow.svg';
import InputLabel from "@/components/Atoms/InputLabel";
import {useUrlType} from "@/components/hooks";
import {Utility} from "@/utils";
import {ReactNode,useEffect,useState} from "react";
import {IComponentMetaData} from "../../SurveyModel/types/commonTypes";
import {INode} from "../../SurveyModel/types/nodeTypes";

interface ISingleLineText {
    node: INode
    children: ReactNode
    name: string
    disabled: boolean
    metaData?: IComponentMetaData
    repeatedElement?:boolean
    onBlur?:()=> void
    type?:string
}

const HtmlContent:React.FC<ISingleLineText>  = (props:ISingleLineText) => {
    //repeatedElement - only available with complex question types with repeated nodes.
    const {node, children,  repeatedElement } = props;
    const [childCollapsed, setChildCollapsed] = useState<boolean>(true);
    const [html, setHtml] =  useState<string | undefined>();
    const {isPatient} = useUrlType();


    useEffect(()=>{
        if(node.htmlContent){
            setHtml(Utility.sanitizeContent(node.htmlContent))
        }
    }, [node.htmlContent]);
   



    
    return (
        <div className={ `html-content-wrap 
        ${Utility.getClassForWidthPx(node)} 
        question-bottom-space-1
         ${Utility.getClassForWidth(node)}  
          risk-score-info ${!repeatedElement ? `user-input flex-1 ${!isPatient ? 'poa-input': '' } 
          input-border-top` : ''}`}>
           
        <div className="dropdown-wrap flex items-center gap-2 justify-start">
           <InputLabel label={node.title} labelClasses="input-label"></InputLabel>
          <div className="icon">
            <img src={childCollapsed ? downArrow : upArrow} alt="Up Arrow" className="icon-img" onClick={()=>{ setChildCollapsed(!childCollapsed) }}/>
          </div>
        </div>
        <div className={`info-section first-line:${childCollapsed ? ' info-collapsed' : ''}`}>
        {node.subTitle  ? <InputLabel type="subTitle" label={node.subTitle } labelClasses="input-label"></InputLabel> : ''}
        {html ? <div dangerouslySetInnerHTML={{ __html: html }} /> : null }

            <div>{children}</div>
        </div>
      
        </div>
    )
}

export default HtmlContent;